import { cn } from '@/lib/utils'
import { useStoreI18n } from '@/store'
import { Typo3ReportsTrails } from '@/types'
import { Typo3Locales } from '@/types/typo3/locales'
import Status from '../../Status'

import { memo } from 'react'

interface Props extends Typo3ReportsTrails {
  isLayoutWinter: boolean
}

const Item = ({
  label,
  status,
  lengthKmPrepared,
  lengthKm,
  conditionLabel,
  dictionary
}: {
  label: string
  status: 'OPEN' | 'CLOSED'
  lengthKmPrepared: number
  lengthKm: number
  statusLabel: string
  conditionLabel: string
  dictionary: Typo3Locales
}) => (
  <div className={'md:gap-2xs gap-gutter flex justify-between max-md:flex-col'}>
    <div className={''}>
      <p>{label}</p>
      <div>
        <span
          className={cn(
            'textstyle-lg-bold max-md:hidden',
            status === 'CLOSED' ? 'text-feedback-red' : 'text-feedback-green'
          )}
        >
          {lengthKmPrepared}
        </span>{' '}
        <span className="max-md:hidden">{dictionary['fe.reports.from']} </span>
        <span
          className={cn(
            'textstyle-lg-bold',
            status === 'CLOSED' ? 'text-feedback-red' : 'text-feedback-green'
          )}
        >
          {lengthKm}
        </span>
        {' km '}
        <span className="max-md:hidden">{dictionary['fe.reports.open']}</span>
      </div>
    </div>
    <div>
      <p className="capitalize">{dictionary['fe.trails.condition']}</p>
      <p className="textstyle-lg-bold">
        {status !== 'CLOSED' ? conditionLabel : '-'}
      </p>
    </div>
    <Status status={status} />
  </div>
)

const AccordionBody = ({ isLayoutWinter, ...data }: Props) => {
  const D = useStoreI18n.use.dictionary()

  return (
    <div className={''}>
      {data?.mapLink && isLayoutWinter && (
        <div className={'max-md:hidden'}>
          <iframe src={data?.mapLink} frameBorder="0"></iframe>
        </div>
      )}
      {data?.listTrails?.map((item, i) => (
        <div
          className={
            'py-md textstyle-sm-regular border-t border-neutral-300 text-neutral-400'
          }
          key={i?.toString()}
        >
          <div>
            <div>{item?.designationLabel}</div>
            <p className="textstyle-lg-bold mb-sm text-neutral-600">
              {item?.title}
            </p>
          </div>
          <div className={'gap-gutter grid grid-cols-2 md:flex md:flex-col'}>
            <Item
              label={D['fe.trails.skating']}
              status={item.statusSkating}
              lengthKmPrepared={item.lengthKmPreparedSkating}
              lengthKm={item.lengthKm}
              statusLabel={item.statusSkatingLabel}
              conditionLabel={item.conditionSkatingLabel}
              dictionary={D}
            />
            <Item
              label={D['fe.trails.classic']}
              status={item.statusClassic}
              lengthKmPrepared={item.lengthKmPreparedClassic}
              lengthKm={item.lengthKm}
              statusLabel={item.statusClassicLabel}
              conditionLabel={item.conditionClassicLabel}
              dictionary={D}
            />
          </div>
        </div>
      ))}
    </div>
  )
}

export default memo(AccordionBody)
